/**
 * Language Modal Component
 */
export class LanguageModal {
    constructor() {
        this.modal = null;
        this.openButtons = null;
        this.closeButtons = null;
        this.overlay = null;
    }

    init() {
        this.modal = document.getElementById("language-modal");
        if (!this.modal) return;

        this.openButtons = document.querySelectorAll(
            '[data-modal-open="language-modal"]'
        );
        this.closeButtons = document.querySelectorAll("[data-modal-close]");
        this.overlay = this.modal.querySelector(".no-language-modal__overlay");

        this.bindEvents();
    }

    bindEvents() {
        this.openButtons.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                this.open();
            });
        });

        this.closeButtons.forEach((btn) => {
            btn.addEventListener("click", () => this.close());
        });

        if (this.overlay) {
            this.overlay.addEventListener("click", () => this.close());
        }

        document.addEventListener("keydown", (e) => {
            if (
                e.key === "Escape" &&
                this.modal.getAttribute("aria-hidden") === "false"
            ) {
                this.close();
            }
        });
    }

    open() {
        this.modal.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
    }

    close() {
        this.modal.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
    }
}
